// extracted by mini-css-extract-plugin
module.exports = {"container":"PageContainer_container__dJDyY","content":"PageContainer_content__NzK17"};